const TabelaClasseFlangeBocais = require('./TabelaClasseFlangeBocais');
const materialsJson = require('./tabelaClasseFlangeBocais.json');

const materiais = materialsJson.map(
  material => new TabelaClasseFlangeBocais(material)
);

module.exports = materiais;